module.exports = __webpack_public_path__ + "img/icon_4_45.247edc45.png";